module.exports = __webpack_public_path__ + "static/media/successLightGreen.8db0d514.svg";